import KidsMode from 'commons/KidsMode/KidsMode';

export default class TransparentHeaderAtTop {
  constructor({ element: $element }){
    this.element = $element;
  }

  init() {
    if (KidsMode.isActive()) {
      return;
    }

    if (this.hasPremiumHeadline()) {
      this.bindScroll();
      this.addTransparentHeader();
      this.addClassToArticleContainer('has-premium-headline');
    }

    if (this.hasTagHeader()) {
      this.addClassToArticleContainer('has-tag-header');
    }

    this.bindClickButton();
  }

  bindScroll() {
    document.addEventListener('scroll', this.addTransparentHeader.bind(this));
  }

  bindClickButton() {
    const kidsActivateButton = this.element.querySelector('.kids-menu__button');
    if(kidsActivateButton) {
      kidsActivateButton.addEventListener('click', () => KidsMode.activate());
    }
  }

  addTransparentHeader() {
    if (this.getScrollTop() > 0) {
      this.element.classList.remove('transparent-header');
      this.changeToOutlineButton();
      this.useTransparentLogo();
    } else {
      this.element.classList.add('transparent-header');
      this.changeToSecondaryButton();
      this.useTransparentLogo(true);
    }
  }

  getLoginButton() {
    return this.element.querySelector('.header-login__button');
  }

  changeToSecondaryButton() {
    if (this.getLoginButton()) {
      this.getLoginButton().classList.add('button-secondary');
      this.getLoginButton().classList.remove('button-outline');
    }
  }

  changeToOutlineButton() {
    if (this.getLoginButton()) {
      this.getLoginButton().classList.remove('button-secondary');
      this.getLoginButton().classList.add('button-outline');
    }
  }

  getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  hasPremiumHeadline() {
    let premiumHeadlineSections = document.querySelectorAll('section[data-component="PremiumHeadline"]');
    return premiumHeadlineSections.length > 0;
  }

  hasTagHeader() {
    let tagHeader = document.querySelector('.tag-header');
    return tagHeader !== null;
  }

  addClassToArticleContainer(classname) {
    let article = document.querySelector('.article-container');
    article !== null && article.classList.add(classname); // jshint ignore:line
  }

  useTransparentLogo(transparent = false){
    let imageElement = this.element.querySelector('.vidio-logo__image');
    let transparentSrc = this.element.dataset.logoTransparent;
    let src = this.element.dataset.logo;
    let currentImageSrc = imageElement.getAttribute("src");
    if(imageElement != null) {
      if(transparent && currentImageSrc !== transparentSrc) {
        imageElement.setAttribute("src", transparentSrc)
      }
      if(!transparent && currentImageSrc !== src) {
        imageElement.setAttribute("src", src)
      }
    }
  }
}
